export default __webpack_public_path__ + "static/media/seLogerNeuf.bcfcadba.svg";